import React, {PureComponent} from 'react';
import Helmet from 'react-helmet';
import {withRouter} from 'react-router-dom';

import DefaultLayout from '../Layout/DefaultLayout.jsx';
import {ImageHeader, ImageHeaderTitle} from '../../components/ImageHeader/ImageHeader.jsx';
import ScrollSpy from '../../components/ScrollSpy/ScrollSpy.jsx';
import ScrollSpyWatch from '../../components/ScrollSpy/ScrollSpyWatch.jsx';
import LinkScroll from '../../components/LinkScroll/LinkScroll.jsx';
import MenuCheum from '../../components/MenuCheum/MenuCheum.jsx';

import conf from '../../conf.js';
import scrollToElement from '../../services/scrollTo.js';

import './CGU.scss';

const title = 'Conditions générales d\'apport d\'affaires';
const description = 'Les présentes Conditions Générales constituent les termes et conditions relatifs au programme d\'Apport d\'affaire';

class BringBusinessCGU extends PureComponent {
  static iTopOffset = conf.topOffset;
  static sTopOffset = BringBusinessCGU.iTopOffset + 'px';

  componentDidMount() {
    scrollToElement(this.props.location.hash);
  }

  render() {
    const siteNameUppercase = conf.site.name.toUpperCase();

    const helmet = <Helmet>
      <title>{title}</title>
      <meta name="description" content={description}/>
      <meta property="og:description" content={description}/>
      <meta property="og:title" content={title}/>
    </Helmet>;

    return (
      <DefaultLayout className="cgu" showSidebarMenu={false} helmet={helmet}>
        <ImageHeader>
          <ImageHeaderTitle>
            <h1>{title}</h1>
          </ImageHeaderTitle>
        </ImageHeader>
        <section id="cgu-body">
          <div className="container">
            <div className="row">
              <div className="col-lg-9">
                <ScrollSpy topOffset={BringBusinessCGU.sTopOffset} group="cgu" name="intro">
                  <div className="mt-5">
                    <div className="mb-5">
                      <p>
                        Les présentes Conditions Générales constituent les termes et conditions relatifs au programme
                        d'Apport d'affaire mis en place par la société {siteNameUppercase} SAS, Société par Actions
                        Simplifiée au capital de 10&nbsp;000 euros dont le siège social est
                        sis {conf.address.street}, {conf.address.postalCode} {conf.address.locality}, immatriculée au
                        RCS de Paris sous le numéro 832&nbsp;390&nbsp;421, représentée par Monsieur Eric Betton, dûment
                        habilité aux fins des présentes
                      </p>
                    </div>
                  </div>
                </ScrollSpy>

                <ScrollSpy topOffset={BringBusinessCGU.sTopOffset} group="cgu" name="objet">
                  <div className="mt-5 pt-5">
                    <div className="mb-5"><h2 id="objet">Objet</h2></div>
                    <div className="mb-5">
                      <p>
                        {siteNameUppercase} propose des consultants freelances dans les fonctions support (achat, RH,
                        finance).
                      </p>
                      <p>
                        Si vous communiquez à {conf.site.name} les informations sur une opportunité d'affaire qui permet
                        à {conf.site.name} de vendre effectivement ses services sur cette opportunité vous recevrez une
                        commission sur la marge réalisée.
                      </p>
                    </div>
                  </div>
                </ScrollSpy>

                <ScrollSpy topOffset={BringBusinessCGU.sTopOffset} group="cgu" name="apporteur-d-affaire">
                  <div className="mt-5 pt-5">
                    <div className="mb-5"><h2 id="apporteur-d-affaire">L'apporteur d'affaire</h2></div>
                    <div className="mb-5">
                      <p>
                        L'Apporteur d'Affaire désigne la personne morale (ou autoentrepreneur) qui fournit
                        à {siteNameUppercase}, via la présente plateforme {conf.site.url.name}, l'ensemble des
                        informations de marché permettant à ce dernier de solliciter un Prospect pour répondre à un
                        besoin spécifique d'intervention d'un consultant pour son compte.
                      </p>
                      <p>
                        Il est entendu que l'Apporteur d'Affaire peut être, au moment de la signature du présent
                        contrat une personne physique.
                      </p>
                      <p>
                        L'Apporteur d'Affaire agit à titre personnel et non à des fins professionnelles et/ou
                        commerciales.
                      </p>
                      <p>
                        L'Apporteur d'Affaire ne peut pas être un(e) employé(e) actuel de {siteNameUppercase} ou un
                        employé d'une société ayant un lien capitalistique avec {siteNameUppercase}.
                      </p>
                    </div>
                  </div>
                </ScrollSpy>

                <ScrollSpy topOffset={BringBusinessCGU.sTopOffset} group="cgu" name="prospect">
                  <div className="mt-5 pt-5">
                    <div className="mb-5"><h2 id="prospect">Prospect</h2></div>
                    <div className="mb-5">
                      <p>
                        « Prospect » désigne toute personne physique recommandée par l'Apporteur d'Affaire, connu ou
                        non-connu par {siteNameUppercase}, ayant la capacité de commander une prestation de services
                        vendable par {siteNameUppercase} et pouvant librement être contacté(e) par {siteNameUppercase}.
                      </p>
                      <p>
                        Le Prospect peut être connu et déjà faire partie de la base de données
                        client {siteNameUppercase} ou avoir précédemment effectué une prestation de services ou tout
                        emploi permanent ou non via {siteNameUppercase}.
                      </p>
                    </div>
                  </div>
                </ScrollSpy>

                <ScrollSpy topOffset={BringBusinessCGU.sTopOffset} group="cgu" name="vente-de-services">
                  <div className="mt-5 pt-5">
                    <div className="mb-5"><h2 id="vente-de-services">Vente de services</h2></div>
                    <div className="mb-5">
                      <p>
                        « Vente de services » : signifie le Placement d'un Consultant par {conf.site.name} chez un
                        client.
                      </p>
                      <p>
                        « Placement » signifie l'execution d'un contrat de prestation de services
                        par {siteNameUppercase} chez son client et sous-traité au Consultant en tant que prestataire
                        indépendant.
                      </p>
                      <p>
                        « Consultant » : signifie professionnel ayant la capacité d'exercer en mission chez un client,
                        quel que soit son statut.
                      </p>
                      <p>
                        « Marge » : signifie le différentiel entre le cout HT d'acquisition d'un Consultant et le
                        Chiffre d'affaires HT que celui-ci génère à {siteNameUppercase}.
                      </p>
                    </div>
                  </div>
                </ScrollSpy>


                <ScrollSpy topOffset={BringBusinessCGU.sTopOffset} group="cgu" name="apport-d-affaire">
                  <div className="mt-5 pt-5">
                    <div className="mb-5"><h2 id="apport-d-affaire">Apport d'affaire</h2></div>
                    <div className="mb-5">
                      <p>
                        <strong>
                          « Prime d'apport » signifie la gratification d'un montant ferme et définitif de la valeur
                          équivalente à TRENTE POUR CENT (30%) de la Marge faite par Twineeds pour un Placement
                          effectué chez un Prospect dans la limite de SIX (6) mois
                        </strong>
                        , en application des conditions précisées dans les présentes Conditions Générales.
                      </p>
                      <p>
                        Pour l'exemple (en HT) :
                      </p>
                      <ul>
                        <li>
                          Si le consultant est placé à une marge 200€/j pour 20 jours de prestation chez le client
                          de {siteNameUppercase}, la Prime d'apport s'élèvera à 200*20*30% = 1200€ pour le mois
                          considéré
                        </li>
                      </ul>
                      <p>
                        Pour tout Placement, la Prime d'apport est due uniquement pour le Placement initial du
                        Consultant. Tout(e)/Toute(s) renouvellement(s), prorogation(s), extension(s)ou nouveau(x)
                        contrat(s) de prestation de services, bon(s) de commande, et/ou de contrat(s) de travail
                        au-delà des 6 premiers mois de Placement sont expressément exclus et n'autorisent pas
                        l'Apporteur d'Affaire à recevoir une Prime d'apport supplémentaire ou une quelconque autre
                        compensation financière de la part de {siteNameUppercase}.
                      </p>
                      <p>
                        Pour l'exemple :
                      </p>
                      <ul>
                        <li>
                          Si le consultant est placé pour durée de 3 mois, renouvelée de 6 mois, la Prime d'apport ne
                          sera due que sur la durée des 6 premiers mois effectués.
                        </li>
                      </ul>
                      <p>
                        La Prime d'apport est personnelle à l'Apporteur d'Affaire et ne pourra être transférée à un
                        tiers, ni être partagée avec un employé actuel de {siteNameUppercase} et/ou avec un Consultant.
                      </p>
                      <p className="bold">
                        L'Apporteur d'Affaire facturera à {siteNameUppercase} le montant de la Prime d'Affaire hors taxe
                        sur la base de la marge effectuée au mois par mois et payée à 45j nets.
                      </p>
                      <p>
                        La date à laquelle le Prospect signe un contrat avec {siteNameUppercase} doit avoir lieu dans
                        les trois (3) mois suivant la date de la soumission des informations du prospect par l'Apporteur
                        d'Affaire sur la Plateforme {siteNameUppercase}.
                      </p>
                      <p>
                        Si la date de signature d'un contrat de prestation de services entre {siteNameUppercase} et le
                        prospect intervient trois (3) mois après la date à laquelle l'Apporteur d'Affaire a soumis les
                        informations sur la Plateforme en Ligne {siteNameUppercase}, aucune Prime d'apport, ni aucune
                        autre compensation, ne sera due à l'Apporteur d'Affaire.
                      </p>
                      <p>
                        Si un Placement de {siteNameUppercase} intervient dans l'entreprise du Prospect pour un autre
                        besoin que celui énoncé par l'Apporteur d'Affaire, aucune Prime d'Apport ou aucune compensation
                        ne sera due.
                      </p>
                      <p>
                        Si les informations transmises par l'Apporteur d'Affaire ont été déjà reçues ou connues par
                        Twineeds avant leur transmission par l'Apporteur d'Affaire, aucune Prime d'Affaire ou aucune
                        compensation ne sera due. {siteNameUppercase} aura la charge de prouver qu'il avait connaissance
                        de ces informations à l'Apporteur d'Affaire.
                      </p>
                      <p>
                        De plus, l'Apporteur d'Affaire s'engage notamment à respecter toutes les règles sociales,
                        fiscales et juridiques relatives à la réception de la/les Prime d'apport(s) et s'engage à
                        effectuer toutes les déclarations nécessaires. L'Apporteur d'Affaire supportera donc les
                        conséquences financières, fiscales et sociales résultant du paiement de la/des Prime
                        d'apport(s). La responsabilité de {siteNameUppercase} ne sera jamais engagée à cet égard.
                        L'Apporteur d'Affaire indemnisera {siteNameUppercase} pour toute perte ou réclamation découlant
                        du non-respect par l'Apporteur d'Affaire des dispositions du présent paragraphe.
                      </p>
                    </div>
                  </div>
                </ScrollSpy>

                <ScrollSpy topOffset={BringBusinessCGU.sTopOffset} group="cgu" name="modification">
                  <div className="mt-5 pt-5">
                    <div className="mb-5">
                      <h2 id="modification">Modification et résiliation des conditions générales</h2>
                    </div>
                    <div className="mb-5">
                      <p>
                        {siteNameUppercase} se réserve le droit, à sa seule discrétion de modifier à tout moment, tout
                        ou partie des présentes Conditions Générales et/ou le montant et/ou la forme de la Prime
                        d'apport. Toute modification sera indiquée sur la présente page et/ou sur la
                        Plateforme {siteNameUppercase} avec la nouvelle version mise à jour des Conditions Générales
                        applicables. {siteNameUppercase} invite donc l'Apporteur d'Affaire à prendre connaissance et à
                        accepter les termes et conditions des Conditions Générales pour chaque opportunité d'Apport
                        d'Affaire.
                      </p>
                      <p>
                        {siteNameUppercase} se réserve le droit à tout moment, à sa seule discrétion de suspendre ou
                        d'interrompre temporairement ou définitivement sans motifs, le programme d'Apporteur
                        d'Affaire, en publiant un avis sur la présente page et/ou sur la
                        Plateforme {siteNameUppercase} ou par tout autre moyen écrit aux Apporteurs d'Affaires.
                      </p>
                    </div>
                  </div>
                </ScrollSpy>

                <ScrollSpy topOffset={BringBusinessCGU.sTopOffset} group="cgu" name="confidentialité">
                  <div className="mt-5 pt-5">
                    <div className="mb-5"><h2 id="confidentialité">Confidentialité et données personnelles</h2></div>
                    <div className="mb-5">
                      <p>
                        Tout Apporteur d'Affaire est confidentiel et ne devra pas être divulgué à un/des tiers, sauf
                        dans les cas requis par la loi.
                      </p>
                      <p>
                        {siteNameUppercase} reconnaît que la protection des personnes physiques à l'égard du traitement
                        des données à caractère personnel est un droit fondamental et respecte vigoureusement ses
                        obligations en se conformant à toutes les lois applicables. {siteNameUppercase} fera de son
                        mieux afin de s'assurer que les informations personnelles fournies restent confidentielles et
                        s'engage à ne conserver et stocker ces informations que le temps nécessaire à leur finalité.
                      </p>
                      <p>
                        L'Apporteur d'Affaire dispose à tout moment, notamment d'un droit d'accès, de rectification,
                        d'effacement, de limitation des données personnelles qu'il aura fournies à {siteNameUppercase}.
                        Par conséquent, pour toute question ou demande s'y rapportant, l'Apporteur d'Affaire devra
                        envoyer un courriel à l'adresse suivante :
                        <a href={`mailto:${conf.site.emails.contact}`}>{conf.site.emails.contact}</a>
                      </p>
                    </div>
                  </div>
                </ScrollSpy>

                <ScrollSpy topOffset={BringBusinessCGU.sTopOffset} group="cgu" name="réclamation">
                  <div className="mt-5 pt-5">
                    <div className="mb-5"><h2 id="réclamation">Réclamation</h2></div>
                    <div className="mb-5">
                      <p>
                        Pour toute réclamation, l'Apporteur d'Affaire devra adresser un courrier recommandé avec avis
                        de réception à la société {siteNameUppercase} SAS, à l'adresse postale de son siège.
                      </p>
                    </div>
                  </div>
                </ScrollSpy>

                <ScrollSpy topOffset={BringBusinessCGU.sTopOffset} group="cgu" name="loi-applicable">
                  <div className="mt-5 pt-5">
                    <div className="mb-5">
                      <h2 id="loi-applicable">Loi applicable et attribution de juridiction</h2>
                    </div>
                    <div className="mb-5">
                      <p>
                        {siteNameUppercase} et l'Apporteur d'Affaire s'engagent à respecter toutes les lois applicables,
                        y compris, mais sans que cette liste ne soit limitative : la législation relative à la
                        protection des données, la lutte contre la corruption, l'égalité des chances et la fiscalité.
                        Les présentes Conditions Générales sont exclusivement soumises au droit français.
                        Préalablement à toute instance judiciaire en relation avec les présentes, {siteNameUppercase} et
                        l'Apporteur d'Affaire se consulteront et négocieront et, reconnaissant leurs intérêts mutuels,
                        tenteront de trouver une solution satisfaisante à l'amiable en application du Décret n°
                        2015-282 du 11 mars 2015. Si {siteNameUppercase} et l'Apporteur d'Affaire ne réussissent pas à
                        formuler un règlement, tout différend ou demande non-résolu sera soumis au Tribunal compétent de
                        Paris.
                      </p>
                    </div>
                  </div>
                </ScrollSpy>

              </div>
              <div className="col-lg-3 d-lg-block d-none">
                <MenuCheum className="cheum-cgu">
                  <ScrollSpyWatch group="cgu" name="objet">
                    <LinkScroll offsetTop={BringBusinessCGU.iTopOffset} to="#objet">
                      Objet
                    </LinkScroll>
                  </ScrollSpyWatch>
                  <ScrollSpyWatch group="cgu" name="apporteur-d-affaire">
                    <LinkScroll offsetTop={BringBusinessCGU.iTopOffset} to="#apporteur-d-affaire">
                      Apporteur d'affaire
                    </LinkScroll>
                  </ScrollSpyWatch>
                  <ScrollSpyWatch group="cgu" name="prospect">
                    <LinkScroll offsetTop={BringBusinessCGU.iTopOffset} to="#prospect">
                      Prospect
                    </LinkScroll>
                  </ScrollSpyWatch>
                  <ScrollSpyWatch group="cgu" name="vente-de-services">
                    <LinkScroll offsetTop={BringBusinessCGU.iTopOffset} to="#vente-de-services">
                      Vente de services
                    </LinkScroll>
                  </ScrollSpyWatch>
                  <ScrollSpyWatch group="cgu" name="apport-d-affaire">
                    <LinkScroll offsetTop={BringBusinessCGU.iTopOffset} to="#apport-d-affaire">
                      Apport d'affaire
                    </LinkScroll>
                  </ScrollSpyWatch>
                  <ScrollSpyWatch group="cgu" name="modification">
                    <LinkScroll offsetTop={BringBusinessCGU.iTopOffset} to="#modification">
                      Modification et résiliation des conditions générales
                    </LinkScroll>
                  </ScrollSpyWatch>
                  <ScrollSpyWatch group="cgu" name="confidentialité">
                    <LinkScroll offsetTop={BringBusinessCGU.iTopOffset} to="#confidentialité">
                      Confidentialité et données personnelles
                    </LinkScroll>
                  </ScrollSpyWatch>
                  <ScrollSpyWatch group="cgu" name="réclamation">
                    <LinkScroll offsetTop={BringBusinessCGU.iTopOffset} to="#réclamation">
                      Réclamation
                    </LinkScroll>
                  </ScrollSpyWatch>
                  <ScrollSpyWatch group="cgu" name="loi-applicable">
                    <LinkScroll offsetTop={BringBusinessCGU.iTopOffset} to="#loi-applicable">
                      Loi applicable et attribution de juridiction
                    </LinkScroll>
                  </ScrollSpyWatch>
                </MenuCheum>
              </div>
            </div>
          </div>
        </section>
      </DefaultLayout>
    );
  }
}

export default withRouter(BringBusinessCGU);